// 2026-08-23 scale a11y — WCAG 2.2, keyboard nav, skip link, focus-visible
"use client";

import { useT } from "@/lib/use-i18n";

export function SkipToContent() {
  const t = useT();
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const main = document.getElementById("main");
    if (main) {
      main.setAttribute("tabindex", "-1");
      main.focus({ preventScroll: false });
    }
  };
  return (
    <a
      href="#main"
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:rounded-md focus:bg-foreground focus:px-3 focus:py-2 focus:text-sm focus:text-background focus:shadow-sm"
    >
      {t("skipToContent")}
    </a>
  );
}
